import { CODE_CHECK_FAILED_MESSAGE } from './fundingApprovalCopy';
import { invoiceRejectionMessages } from './invoiceRejectionMessages';
import type { MessagesByTarget } from './invoiceRejectionMessages';
import type { FundingPurpose, InvoiceLinePayload, InvoiceRejectionReason } from '../types/agreements.types';

export type CodeCheckStatus = 'idle' | 'checking' | 'accepted' | 'rejected';

export interface CodeCheckFailure {
    fieldMessage: string | null;
    overBalanceMessage: string | null;
}

export interface CodeCheckView extends CodeCheckFailure {
    status: CodeCheckStatus;
}

export interface CodeCheckKeyParts {
    agreementId: string | undefined;
    purpose: FundingPurpose;
    approvalId: string | null;
    code: string;
    selectionKey: string;
}

export const codeCheckKey = (parts: CodeCheckKeyParts): string => JSON.stringify(parts);

const joined = (messages: string[]): string | null => (messages.length > 0 ? messages.join(' ') : null);

export function codeCheckFailure(reasons: InvoiceRejectionReason[], lines: InvoiceLinePayload[]): CodeCheckFailure {
    if (reasons.length === 0) return { fieldMessage: CODE_CHECK_FAILED_MESSAGE, overBalanceMessage: null };

    const { byTarget } = invoiceRejectionMessages(reasons, lines, []);
    return {
        fieldMessage: joined([...byTarget.code, ...byTarget.submit]),
        overBalanceMessage: joined(byTarget.over_balance),
    };
}

export function placeCodeCheck(
    check: CodeCheckView,
    placed: MessagesByTarget,
): { codeError: string | null; overBalance: string[] } {
    const codeError =
        check.status === 'rejected' ? check.fieldMessage : check.status === 'idle' ? joined(placed.code) : null;
    if (check.status === 'accepted') return { codeError, overBalance: [] };

    const checkMessage = check.status === 'rejected' ? check.overBalanceMessage : null;
    const checkOverBalance = checkMessage && !placed.over_balance.includes(checkMessage) ? [checkMessage] : [];
    return { codeError, overBalance: [...placed.over_balance, ...checkOverBalance] };
}
